import { defineComponent } from "vue";

import { ImplantableDevice } from "../../../../../../models/pal-health-history/implantable-device";
import {
    brandNameTooltip,
    deviceLabelTooltip,
    deviceTooltip,
    gmdnPtNameTooltip,
    hctTooltip,
    mriTooltip,
    versionTooltip
} from "../ImplantableDeviceSection/ImplantableDeviceTooltip";
import { formatDate } from "../../../../../../common/vue-helpers/modifiers/value-modifier";

export default defineComponent({
    props: {
        implantableDevice: {
            type: ImplantableDevice,
            default: null
        }
    },

    data() {
        return {
            gmdnPtNameTooltip: gmdnPtNameTooltip as string,
            deviceTooltip: deviceTooltip as string,
            brandNameTooltip: brandNameTooltip as string,
            versionTooltip: versionTooltip as string,
            mriTooltip: mriTooltip as string,
            deviceLabelTooltip: deviceLabelTooltip as string,
            hctTooltip: hctTooltip as string,
            formatDate
        };
    }
});
